// extracted by mini-css-extract-plugin
export default {"foretagSearchResult":"ForetagSearchResult_foretagSearchResult__GcfzI","grunduppgifter":"ForetagSearchResult_grunduppgifter__3Roaa"};